import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const CarServicingHappyCustomerCard = ({ promotionData }) => {
    const { highlights = [], footer = "" } = promotionData || {};

    const { info: leftInfo = "", value: leftValue = "" } = highlights[0] || {};
    const { info: rightInfo = "", value: rightValue = "" } = highlights[1] || {};

    if (highlights.length === 0) {
        return null;
    }

    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.wrapper"}>
                <div styleName={"styles.leftSection"}>
                    <p styleName={"styles.heading"}>{leftValue}</p>
                    <p styleName={"styles.subHeading"}>{leftInfo}</p>
                </div>
                <div styleName={"styles.rightSection"}>
                    <p styleName={"styles.heading"}>{rightValue}</p>
                    <p styleName={"styles.subHeading"}>{rightInfo}</p>
                </div>
            </div>
            {footer && <p styleName={"styles.sourceData"}>{footer}</p>}
        </div>
    );
};

CarServicingHappyCustomerCard.propTypes = {
    promotionData: PropTypes.object
};

export default CarServicingHappyCustomerCard;
